import React, { useContext, useEffect, useState } from "react";
import AboutUsBanner from "./aboutUsBanner";
import "../../assets/css/--page-aboutus.css";
import HistorySection from "./historySection";
import ValuesSection from "./valuesSection";
import ExploreSection from "./exploreSection";
import IntroSection from "./introSection";
import ScrollToTop from "../../components/ScrollToTop";

export default function MenuPage() {

  return (
    <div className="about-us-page">
      <AboutUsBanner />
      <HistorySection />
      <IntroSection />
      <ValuesSection />
      <ExploreSection />
      <ScrollToTop />
    </div>
  );
}
